import StarIcon from "@/components/icons/star-icon";

export function DoctorStarRating(props: { rating: number }) {
  const roundedRating = Math.ceil(props.rating);

  return (
    <div className="flex gap-1">
      {Array.from({ length: roundedRating }, (_, index) => (
        <StarIcon key={index} className="w-3 h-3" />
      ))}
    </div>
  );
}
